import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { FbShareModule } from '../fb-share/fb-share.module';
import { SupportCardComponent } from './components/support-card/support-card.component';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  imports: [
    CommonModule,
    FbShareModule,
    SharedModule,
    MatCardModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule
  ],
  declarations: [SupportCardComponent],
  exports: [SupportCardComponent],
})
export class SupportCardModule { }
